// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import { v4 } from "uuid";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import Skeleton from "@mui/material/Skeleton";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import appConfigs from "@/configs";
import { Map } from "./map";
import { Marker } from "./marker";

export function GoogleMap({
  latitude,
  longitude,
  zoom,
  markers,
  height = "400px",
  width = "100%",
}: any) {
  const render = (status: any) => {
    switch (status) {
      case Status.LOADING:
        return <Skeleton sx={{ width, height }} />;
      default:
        return null;
    }
  };

  return (
    <Wrapper apiKey={appConfigs.googleMapsKey} render={render}>
      <Map latitude={latitude} longitude={longitude} zoom={zoom} height={height} width={width}>
        {!isEmpty(markers) &&
          markers.map((m: any) => (
            <Marker key={v4()} position={{ lat: m.latitude, lng: m.longitude }} />
          ))}
      </Map>
    </Wrapper>
  );
}

GoogleMap.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  markers: PropTypes.arrayOf(
    PropTypes.shape({ latitude: PropTypes.number, longitude: PropTypes.number })
  ),
  zoom: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
